import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { ICinemaPalette } from '../palette';
import { MiniGameId } from './types';
import { IMiniGameEntry } from './catalog';
import { GameGlyph } from './gameIcons';
import { KEY_GUARD_ACTIVATE } from './keyGuard';
import { keepFocus } from './gameOptions';
import { getSwitcherStyles } from './switcherStyles';
import { MINI_GAME_SWITCH_LABEL } from './constants';

interface IGameSwitcherProps {
  palette: ICinemaPalette;
  games: IMiniGameEntry[];
  activeId: MiniGameId;
  onSwitch: (id: MiniGameId) => void;
}

const GameSwitcher = ({
  palette,
  games,
  activeId,
  onSwitch,
}: IGameSwitcherProps) => {
  const classes = useMemo(() => getSwitcherStyles(palette), [palette]);

  return (
    <Box
      role="group"
      aria-label={MINI_GAME_SWITCH_LABEL}
      sx={classes.switcher}
      data-testid="myta-minigame-switcher"
    >
      {games.map((game) => {
        const active = game.id === activeId;

        return (
          <Box
            key={game.id}
            component="button"
            type="button"
            sx={[classes.tab, active && classes.tabActive]}
            onMouseDown={keepFocus}
            onClick={() => onSwitch(game.id)}
            title={game.title}
            aria-label={game.title}
            aria-pressed={active}
            {...KEY_GUARD_ACTIVATE}
            data-testid={`myta-minigame-switch-${game.id}`}
          >
            <GameGlyph id={game.id} accent={palette.accentHi} size={20} still />
            <Box component="span" sx={classes.tabLabel}>
              {game.title}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default GameSwitcher;
